import { useMutation, useQuery } from "@tanstack/react-query";
import { dosingScheduleApiService } from "modules/Clinical/DosingSchedule/api/dosingSchedule.api";

export const useSubmitDosingSchedule = () => {
    return useMutation({
        mutationFn: async (payload: any) => {
            const response = await dosingScheduleApiService.updateData(payload);
            return response.data;
        },
    });
};

export const useUpdateSubjectDoseTime = () => {
    return useMutation({
        mutationFn: async (payload: {
            studyid: number;
            subjectdosingeventid: number;
            scheduleddosetime: string;
        }) => {
            const response = await dosingScheduleApiService.updateSubjectDoseTime(payload);
            return response;
        },
    });
};

export const useInsertDosingSchedule = () => {
    return useMutation({
        mutationFn: async (payload: any) => {
            const response = await dosingScheduleApiService.insertData(payload);
            return response.data;
        },
    });
};

export const useSelectAllDosingSchedule = (payload: any, options: any = {}) => {
    return useQuery({
        queryKey: ["DosingSchedule-selectAll", payload],
        queryFn: async () => {
            const response = await dosingScheduleApiService.selectAllData(payload);
            return response.data;
        },
        enabled: !!payload?.studyid,
        ...options
    });
};

/* ================================================================
   TIMEPOINT EXECUTION — follows exact project pattern
   (same as useReturnsAccountability / SelectQuery)
================================================================ */

export const useVerifyDosingSchedule = () => {
    const verifyPinMutation = useMutation({
        mutationFn: async (payload: {
            studyid: number;
            periodid: number;
            subjectsperstation: Record<string, string[]>;
            verifypin: string;
            verifiedby: number;
        }) => {
            const response = await dosingScheduleApiService.verifyData(payload);
            return response.data;
        },
    });

    return { verifyPinMutation };
};

export const useGenerateDosingReport = () => {
    return useMutation({
        mutationFn: async (payload: { studyid: number; periodid: number }) => {
            const response = await dosingScheduleApiService.getDosingReport(payload);
            return response;
        },
    });
};
